export default "__VITE_ASSET__DfeyX49c__"